export default "__VITE_ASSET__082dd476__"